module.exports = __webpack_public_path__ + "img/9788954614351.0c3d767a.jpg";